import {fromJS, List} from 'immutable';
import * as setsActionTypes from '../actions/setsActionTypes';
import * as workspacesActionTypes from '../actions/workspacesActionTypes';
import { getKeyPath } from '../utils/immutableUtils';
import * as categoriesActionTypes from "../actions/categoriesActionTypes";

const initialState = fromJS({
  setsList: [],
  isRetrievingRoot: false,
  rootRequest: null,
  deleteRequests: {},
  editRequests: {},
  createRequests: [],
  retrieveChildrenRequests: {},
});

const createSetData = (id, name, description) => (fromJS({
  n: name,
  d: description,
  t: 'L',
  i: id,
  x: '0',
  opk: '0',
  ch: 'FALSE',
  u: '',
  ct: [],
  users: [],
  wsType: 'SET',
  previews: [],
}));

const sets = (state = initialState, action) => {
  switch (action.type) {
    case setsActionTypes.SETS_RETRIEVE_REQUEST:
      if (state.get('rootRequest')) {
        // cancel the current root request promise since it exists
        state.get('rootRequest').cancel();
      }

      return state
        .set('isRetrievingRoot', true)
        .set('rootRequest', action.requestPromise)
        ;
    case setsActionTypes.SETS_RETRIEVE_SUCCESS:
      return state
        .set('isRetrievingRoot', false)
        .set('rootRequest', null)
        .set('setsList', fromJS(action.setsList))
        .set('retrieveChildrenRequests', fromJS({}))
        ;
    case setsActionTypes.SETS_RETRIEVE_FAILURE:
      return state
        .set('isRetrievingRoot', false)
        .set('rootRequest', action.err)
        ;
    case setsActionTypes.SETS_CREATE_REQUEST: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      if (foundRequestIndex !== undefined) {
        // request with same details already exist, so just overwrite that one
        return state
          .setIn(['createRequests', foundRequestIndex, 'request'], action.requestPromise)
          .setIn(['createRequests', foundRequestIndex, 'workspaceDescription'],
            action.workspaceDescription)
          ;
      }

      return state.set('createRequests', state.get('createRequests').push(fromJS({
        workspaceName: action.workspaceName,
        workspaceParentID: action.workspaceParentID,
        workspaceDescription: action.workspaceDescription,
        request: action.requestPromise,
      })));
    }
    case setsActionTypes.SETS_CREATE_SUCCESS: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      if (foundRequestIndex !== undefined) {
        const newState = state.deleteIn(['createRequests', foundRequestIndex]);

        // adds new workspace to root level workspace
        return newState.set('setsList', state.get('setsList')
          .push(createSetData(
            action.workspaceID,
            action.workspaceName,
            action.workspaceDescription,
          )));
      }

      return state;
    }
    case setsActionTypes.SETS_CREATE_FAILURE: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      if (foundRequestIndex !== undefined) {
        return state.setIn(['createRequests', foundRequestIndex, 'request'], action.err);
      }

      return state;
    }
    case setsActionTypes.SETS_EDIT_REQUEST:
      return state.setIn(['editRequests', action.workspaceID], fromJS({
        workspaceName: action.workspaceName,
        workspaceDescription: action.workspaceDescription,
        request: action.requestPromise,
      }));
    case setsActionTypes.SETS_EDIT_SUCCESS:
      if (state.getIn(['editRequests', action.workspaceID])) {
        let newState = state.deleteIn(['editRequests', action.workspaceID]);

        if (action.workspaceName || action.workspaceDescription) {
          const foundPath = getKeyPath(state.get('setsList'), 'i', action.workspaceID, 'ct');
          if (foundPath) {
            if (action.workspaceName) {
              newState = newState.setIn(['setsList', ...foundPath, 'n'], action.workspaceName);
            }
            if (action.workspaceDescription) {
              newState = newState.setIn(['setsList', ...foundPath, 'd'], action.workspaceDescription);
            }
          }
        }

        return newState;
      }
      return state;
    case setsActionTypes.SETS_EDIT_FAILURE:
      return state.setIn(['editRequests', action.workspaceID, 'request'], action.err);
    case setsActionTypes.SETS_DELETE_REQUEST: {
      const foundPath = getKeyPath(state.get('setsList'), 'i', action.workspaceID, 'ct');
      if (foundPath) {
        const workspaceData = state.getIn(['setsList', ...foundPath]);
        return state.setIn(['deleteRequests', action.workspaceID], fromJS({
          workspaceName: workspaceData.get('n'),
          workspaceDescription: workspaceData.get('d'),
          request: action.requestPromise,
        }));
      }

      return state;
    }
    case setsActionTypes.SETS_DELETE_SUCCESS: {
      const foundPath = getKeyPath(state.get('setsList'), 'i', action.workspaceID, 'ct');
      return state
        .deleteIn(['deleteRequests', action.workspaceID])
        .deleteIn(['setsList', ...foundPath])
        ;
    }
    case setsActionTypes.SETS_DELETE_FAILURE:
      return state.setIn(['deleteRequests', action.workspaceID, 'request'], action.err);
    case setsActionTypes.SET_LIST_COLLAPSE:
      return state.setIn(['deleteRequests', action.categoryID, 'request'], action.err);
    case setsActionTypes.SET_LIST_CLEAR: {
      let newCategoryList = state.get('setsList');
      const foundPath = getKeyPath(state.get('setsList'), 'i', action.categoryID, 'ct');

      if (foundPath) {
        newCategoryList = state
          .get('setsList')
          .setIn([...foundPath, 'ct'], new List());
      }
      return state
        .set('setsList', newCategoryList)
        ;
    }
    case workspacesActionTypes.WORKSPACES_CANCEL_ALL_REQUESTS:
      state.get('retrieveChildrenRequests').find((value) => {
        if (value.cancel) {
          value.cancel();
        }
        return false;
      });

      if (state.get('rootRequest') && state.get('rootRequest').cancel) {
        state.get('rootRequest').cancel();
      }

      return state
        .set('isRetrievingRoot', false)
        .set('rootRequest', null)
        .set('retrieveChildrenRequests', fromJS({}))
        ;
    case workspacesActionTypes.WORKSPACES_CANCEL_CREATE_REQUEST: {
      const foundRequestIndex = state.get('createRequests').findKey(createRequest =>
        createRequest.get('workspaceName') === action.workspaceName &&
        createRequest.get('workspaceParentID') === action.workspaceParentID
      );

      if (foundRequestIndex !== undefined) {
        // first, cancel the promise
        const request = state.getIn(['createRequests', foundRequestIndex, 'request']);

        if (request && request.cancel) {
          request.cancel();
        }

        return state.deleteIn(['createRequests', foundRequestIndex]);
      }

      return state;
    }
    case workspacesActionTypes.WORKSPACES_RETRIEVE_INFO_REQUEST:
      return state;
    case workspacesActionTypes.WORKSPACES_RETRIEVE_INFO_SUCCESS:
      const foundPath = getKeyPath(state.get('setsList'), 'i', action.workspaceID, 'ct');

      let newCategoryList;
      if (foundPath) {
        newCategoryList = state
          .get('setsList')
          .setIn([...foundPath, 'users'], fromJS(action.workspaceUsers));
      }

      return state
        .set('setsList', newCategoryList || state.get('setsList'));
    case workspacesActionTypes.WORKSPACES_RETRIEVE_INFO_FAILURE:
      return state;
    default:
      return state;
  }
};

export default sets;
